<template>
    <div class="overlay" v-if="errors.length > 0">
        <div class="error" v-for="error in errors" :key="error.id">
            {{error}}
            <span class="fa fa-close" v-on:click="closeError()"></span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { types } from "@/types";

export default {
  name: "Overlay",

  computed: mapState(["errors"]),

  methods: {
    closeError() {
      this.$store.commit(types.CLEAR_ERRORS);
    }
  }
};
</script>

<style>
.overlay {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 0 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 24px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #ffffff;
  z-index: 9999;
}
.error {
  padding: 15px 25px;
  background-color: #0d76ffaf;
  border-radius: 8px;
  position: relative;
  margin-bottom: 10px;
  line-height: 28px;
}
.error .fa-close {
  position: absolute;
  right: 10px;
  top: 8px;
  font-size: 16px;
}
.error .fa-close:hover {
  cursor: pointer;
}
</style>

